module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row header-block"
  }, [_c('div', {
    staticClass: "span-14-lg offset-1-lg span-14-md offset-1-md span-16-sm span-14-sm offset-1-sm span-14-xs offset-1-xs"
  }, [_c('p', {
    staticClass: "large"
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-327a557e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/header_block.vue
// module id = 608
// module chunks = 1